import { roundNumber, roundToPrecision } from '@shared/utils';
import { OptionsSeatFormValue } from '@shared/components/delivery-cargo/components/delivery-cargo-places/delivery-cargo-places.models';
import { OptionsSeatControlNames } from '@shared/components/delivery-cargo/components/delivery-cargo-places/delivery-cargo-places.enums';
import { ValidatorFn, Validators } from '@angular/forms';
import { PLACE_COST_INPUT_CONFIG } from '@shared/components/delivery-cargo/components/delivery-cargo-places/delivery-cargo-places.constants';

export function calculateVolumetricVolume(length: number, width: number, height: number): number {
  if (!height || !length || !width) {
    return 0;
  }

  // Magic number 4000 is taken from the formula that NP uses to calculate volumetric volume.
  const volumetricVolume = roundNumber((length * width * height) / 4000);

  // Magic number 0.1 is taken from the formula that NP uses to calculate volumetric volume, and it's a minimum value.
  return Math.max(0.1, volumetricVolume);
}

export function checkIsCargoSpecial(
  weight: number,
  volumetricVolume: number,
  length: number,
  width: number,
  height: number,
): boolean {
  // Magic numbers are taken from the formula that NP uses to calculate special cargo.
  return (
    weight >= 0.1 &&
    weight <= 30 &&
    volumetricVolume >= 0.1 &&
    volumetricVolume <= 30 &&
    length <= 120 &&
    width <= 120 &&
    height <= 120
  );
}

export function getHalfCost(cost: string): string {
  const halfCostNumber = (Number(cost) || 0) / 2;
  return halfCostNumber ? roundToPrecision(halfCostNumber, 2) : '';
}

export function getOptionsSeatMainDimensions(optionsSeat: OptionsSeatFormValue): {
  length: number;
  width: number;
  height: number;
  weight: number;
  volumetricVolume: number;
} {
  const length = Number(optionsSeat[OptionsSeatControlNames.VolumetricLength]);
  const width = Number(optionsSeat[OptionsSeatControlNames.VolumetricWidth]);
  const height = Number(optionsSeat[OptionsSeatControlNames.VolumetricHeight]);
  const weight = Number(optionsSeat[OptionsSeatControlNames.Weight]);
  const volumetricVolume = Number(optionsSeat[OptionsSeatControlNames.VolumetricVolume]);

  return { length, width, height, weight, volumetricVolume };
}

export function placeNumericValidators(isTemplate: boolean = false, minValue = 0.1): ValidatorFn {
  return Validators.compose([...(isTemplate ? [] : [Validators.required]), Validators.min(minValue)]);
}

export function placeCostValidators(isTemplate: boolean = false): ValidatorFn {
  return Validators.compose([
    ...(isTemplate ? [] : [Validators.required]),
    Validators.min(PLACE_COST_INPUT_CONFIG.minValue),
    Validators.max(PLACE_COST_INPUT_CONFIG.maxValue),
  ]);
}
